var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"no-record-selected"}},[_c('h2',[_vm._v("No Record Selected")]),_c('p',[_vm._v("Select an record or "),_c('CreateNewInventoryRecordLink',{attrs:{"text":"create a new record","icon":"false"}}),_vm._v(".")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }